import React, { useContext } from "react";
import { useTheme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import BlockIcon from "@material-ui/icons/Block";

import { AuthContext } from "../../context/Auth/AuthContext";
import AvisoAcesso from "../../components/AvisoAcesso";

const formatDate = (iso) => {
	if (!iso) return null;
	try { return new Date(iso).toLocaleString("pt-BR"); } catch { return null; }
};

// Texto NEUTRO de propósito. Esta tela atende dois casos do ERP que chegam aqui com o mesmo
// marcador (ERR_USER_INACTIVE), porque `Users.ativo` espelha o "usuário WhatsApp" e não o
// `usu_ativo`: usuário desativado no ERP, e usuário ativo que teve o "usuário WhatsApp"
// desmarcado. Dizer "seu usuário está desativado" no segundo caso manda a pessoa pedir
// reativação de um acesso que ela não perdeu — ela só perdeu o atendimento.
const BlockedUser = () => {
	const theme = useTheme();
	const { user, handleLogout } = useContext(AuthContext);
	const desativadoEm = formatDate(user?.desativadoEm);
	const desativadoPor = user?.desativadoPorUser?.name;

	return (
		<AvisoAcesso
			icone={<BlockIcon />}
			corIcone={theme.palette.error.main}
			titulo={`${user?.name ? `${user.name}, ` : ""}seu acesso ao atendimento está desativado`}
			mensagem="Seu usuário não está habilitado para atender pelo WhatsApp. Fale com o administrador do sistema."
			detalhe={(desativadoPor || desativadoEm) && (
				<>
					{desativadoPor && <div>Desativado por: {desativadoPor}</div>}
					{desativadoEm && <div>Desativado em: {desativadoEm}</div>}
				</>
			)}
			acoes={
				<Button variant="outlined" color="primary" onClick={handleLogout}>
					Sair
				</Button>
			}
		/>
	);
};

export default BlockedUser;
